
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionBOMGrid extends Serenity.EntityGrid<MFGTransactionBOMRow, any> {
        protected getColumnsKey() { return 'Production.MFGTransactionBOM'; }
        protected getDialogType() { return MFGTransactionBOMDialog; }
        protected getIdProperty() { return MFGTransactionBOMRow.idProperty; }
        protected getInsertPermission() { return MFGTransactionBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return MFGTransactionBOMRow.localTextPrefix; }
        protected getService() { return MFGTransactionBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}